export default __webpack_public_path__ + "media/images/brighteon-social/Icon-New-Gray-908cf32e253598f0a4f5ed25203862b4.svg";